import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { CustomSignInPage } from './SignInPage';

export const signInModule = createFrontendModule({
  pluginId: 'app',
  extensions: [CustomSignInPage],
});
